import { jsx } from "react/jsx-runtime";
import { usePinch } from "@use-gesture/react";
import React from "react";
const PinchHelper = React.forwardRef(function PinchHelper2({ children, onPinch, style, className, ...rest }, forwardedRef) {
  const internalRef = React.useRef();
  const target = forwardedRef || internalRef;
  usePinch(
    (arg) => {
      if (onPinch && arg.delta && arg.delta[0] !== 0) {
        onPinch(arg);
      }
    },
    {
      target,
      eventOptions: { passive: false }
    }
  );
  React.useEffect(() => {
    const el = target.current;
    if (!el) return;
    const handleWheel = (e) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
        e.stopPropagation();
        const d = e.deltaY < 0 ? 0.1 : e.deltaY > 0 ? -0.1 : 0;
        if (d !== 0 && onPinch) {
          onPinch({ delta: [d], event: e });
        }
      }
    };
    el.addEventListener("wheel", handleWheel, { passive: false });
    return () => {
      el.removeEventListener("wheel", handleWheel);
    };
  }, [onPinch]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref: target,
      style: { overflowX: "hidden", ...style },
      className: `tg-pinch-helper ${className || ""}`,
      ...rest,
      children
    }
  );
});
export default PinchHelper;
